import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "../components/Common";
import { API_BASE } from "../AppConfig";
import Message from "../components/Message";
import { newDefaultJobState } from "../redux_store/jobState";
import { changeMainPage } from "../redux_store/appState";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import BSL_Dialog from "../components/BSL_Dialog";

const useStyles = makeStyles({
    root: {
        // transform: 'translateY(-100%)',
        color: "red",
        textAlign: "center",
        pointerEvents: "none",
    },
    dropContainer: {
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        margin: "0",
        width: "100%",
        height: "100%",
        // border: '4px dashed #4aa1f3',
        position: "fixed",
        zIndex: "10000",
        top: "0",
        left: "0",
    },
    uploadIcon: {
        width: "50px",
        height: "50px",
        background: "url(../images/upload.png) no-repeat center center",
        backgroundSize: "100%",
        textAlign: "center",
        margin: "0 auto",
        paddingTop: "30px",
    },
    dropMessage: {
        textAlign: "center",
        color: "white",
        fontSize: "20px",
    },
});

export default function DragDrop(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [background, setBackground] = React.useState("none");
    const [message, setMessage] = React.useState(false);
    const [dialogData, setDialogData] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const [fileData, setFileData] = React.useState([]);
    const [readComplete, setReadComplete] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState(false);
    const user = useSelector((state) => state.app.user);
    const config = useSelector((state) => state.config);
    const app = useSelector((state) => state.app);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    React.useEffect(() => {
        if (!loaded) {
            let el = document.body;
            el.addEventListener("dragenter", (event) => dragEnter(event));
            el.addEventListener("dragleave", (event) => dragLeave(event));
            el.addEventListener("dragover", (event) => dragOver(event));
            el.addEventListener("drop", (event) => fileDrop(event));
            setLoaded(true);
        }
    }, [loaded]);

    const dragOver = (e) => {
        setBackground("#111111AA");
        e.preventDefault();
    };

    const dragEnter = (e) => {
        setBackground("#111111AA");
        e.preventDefault();
    };

    const dragLeave = (e) => {
        setBackground("none");
        e.preventDefault();
    };

    const fileDrop = (e) => {
        setBackground("none");
        e.preventDefault();
        const files = e.dataTransfer.files;

        if (files.length) {
            handleFiles(files);
        }
    };

    const validateFile = (file) => {
        //
        if (file.name.endsWith(".vqu") || file.name.endsWith(".vqd")) {
            return true;
        }
        return false;
    };

    const handleFiles = (files) => {
        setFileData([]);
        setReadComplete(false);
        let valid_files = [];
        for (let i = 0; i < files.length; i++) {
            if (validateFile(files[i])) {
                valid_files.push(files[i]);
            } else {
            }
        }
        readmultifiles(valid_files);
    };

    React.useEffect(() => {
        if (readComplete && fileData.length > 0) {
            let filenames = [];
            for (let file of fileData)
                filenames.push(
                    <>
                        {file.name}
                        <br />
                    </>
                );
            setMessage(
                <>
                    <CircularProgress style={{ color: "white" }} />
                    <br />
                    <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                        Importing Files...
                        <br />
                        {filenames}
                    </Typography>
                </>
            );
            setBackground("#111111AA");

            let api_url = API_BASE() + "JobImport/";
            fetchTimeout(
                api_url,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        imported_data: fileData,
                        job_template: newDefaultJobState(config, "", user),
                    }),
                },
                120000
            )
                .then((response) => response.json())
                .then((json) => {
                    if (json.Error) {
                        throw json.Error;
                    }
                    setMessage(false);
                    setBackground("none");
                    setShowMessage({
                        type: "success",
                        message: json?.Success ? json?.Success : "Files Successfuly imported",
                    });
                    dispatch(changeMainPage("Recall"));
                    // props.setLoading(true);
                    // dispatch(updateRecallListFromWeb(props.businessCode))
                    // .then(() => props.setLoading(false));
                })
                .catch((e) => {
                    setMessage(false);
                    setBackground("none");
                    setDialogData({
                        title: "Error importing Job Files",
                        message: [<>{e?.message ? e.message : e}</>],
                        primaryActionText: "OK",
                        primaryAction: () => {},
                    });
                    // setShowMessage({
                    //     type: "error",
                    //     message: (e?.message ? e.message : e),
                    // });
                    dispatch(changeMainPage("Recall"));

                    // props.setLoading(true);
                    // dispatch(updateRecallListFromWeb(props.businessCode))
                    // .then(() => props.setLoading(false));
                });
        }
    }, [readComplete]);

    const readmultifiles = (files) => {
        var reader = new FileReader();
        var file_data = [];
        function readFile(index) {
            if (index >= files.length) {
                setFileData(file_data);
                setReadComplete(true);
                return;
            }
            var file = files[index];
            reader.onload = function (e) {
                // get file content
                var bin = e.target.result;
                // let new_fileData = [...fileData];
                file_data.push({ data: bin, name: file.name });
                // do sth with bin
                readFile(index + 1);
            };
            reader.readAsDataURL(file);
        }
        readFile(0);
    };

    return (
        <div className={classes.root} draggable={true}>
            <div
                className={classes.dropContainer}
                // onDragOver={dragOver}
                // onDragEnter={dragEnter}
                // onDragLeave={dragLeave}
                // onDrop={fileDrop}
                style={{ background: background, display: background != "none" ? "flex" : "none" }}
            >
                <div className={classes.dropMessage}>
                    <div className={classes.uploadIcon}></div>
                    {message ? message : "Drag & Drop quote files (VQU, VQD) here to import"}
                </div>
            </div>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />

            <BSL_Dialog
                title={dialogData.title}
                open={dialogData}
                onClose={() => setDialogData(false)}
                button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                button1Click={() => {
                    setDialogData(false);
                    if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                }}
                button2Text={dialogData?.secondaryActionText}
                button2Click={() => {
                    setDialogData(false);
                    if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                }}
            >
                {dialogData.message}
            </BSL_Dialog>
        </div>
    );
}
